'use client';

import { useState } from 'react';
import axios from 'axios';

export function useAddPackageBooking() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [data, setData] = useState(null);

  const addBooking = async (payload: object) => {
    setLoading(true);
    setError(null);

    try {
      const response = await axios.post(
        `${process.env.NEXT_PUBLIC_API_URL}/travel/packages/v1/booking`,
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      setData(response.data);
      return response.data;
    } catch (err) {
      console.error('Add booking error:', err);

      if (err.response?.status === 401) {
        setError('Your session has expired. Please log in again.');
      } else if (err.response?.status === 403) {
        setError("You don't have permission to make a booking.");
      } else {
        const errorMessage =
          err.response?.data?.message ||
          err.message ||
          'Failed to make booking';
        setError(errorMessage);
      }
      return null;
    } finally {
      setLoading(false);
    }
  };

  return { addBooking, loading, error, data };
}
